import { useMutation } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import { AltaviaConnectApi } from "@/config/apiClient";
import { type ApiErrorResponse } from "@/config/apiClient.types";
import { createApiClient } from "@/config/createApiClient";
import { handleReactQueryErrors } from "@/helpers/errors";
import { currentWorkspaceAtom } from "@/store";

const apiClient = createApiClient(AltaviaConnectApi);

export const useAwsConnect = () => {
  const currentWorkspace = useAtomValue(currentWorkspaceAtom);

  const useGetQuoteFromAws = () =>
    useMutation({
      // Todo: remove this custom error handling when API will return empty 201 instead of 4xx
      meta: { suppressError: true },
      onError: (error: Error | ApiErrorResponse) => {
        if (
          "status" in error &&
          (error.status === 400 || error.status === 422)
        ) {
          return;
        }
        handleReactQueryErrors(error);
      },
      mutationKey: [
        "quoteFromAws",
        currentWorkspace?.accountId,
        currentWorkspace?.organizationId,
        currentWorkspace?.id,
      ],
      mutationFn: ({
        quoteNumber,
        orderId,
      }: {
        quoteNumber: string;
        orderId: string;
      }) =>
        apiClient.altaviaConnectControllerGetQuoteFromAws({
          accountId: currentWorkspace?.accountId,
          organizationId: currentWorkspace?.organizationId,
          workspaceId: currentWorkspace?.id,
          quoteNumber: quoteNumber,
          orderId: orderId,
        }),
    });

  return {
    useGetQuoteFromAws,
  };
};
